/** ContentType, is the type of Content of YourApp */
export enum ContentType {
  // ATTENTION: On some change is need to see the PortalCommon.YouAPP.ContentType
  // new entries must checked also in next places:
  // contentTypes.ts > ContentDir
  // contentTypes.ts > GetContentDirFromType
  // objectObserver.service.ts > CreateNewManager
  // objectObserver.service.ts > CreateServerCallHelper
  // objectObserver.service.ts > autoSyncAllowedContentTypes
  News = 0,
  Coupon = 1,
  Event = 2,
  Aktion = 3,
  Location = 4,
  Menu = 5,
  Bonussystem = 6,
  Reservation = 7,
  WebVoucher = 8,
  Impressum = 9,
  Term = 10,
  Home_Slider = 11,
  Home_PrioTile = 12,
  Home_Tile = 13,
  Settings = 14,
  Navigation = 15,
  Item_Group = 16,
  sub_Product = 17, // attention is a sub of MenuSettings
  Product_Group = 18,
  ExternalLink = 19,
  // Webshop = 20, Achtung! siehe MenuSettings
  Bonussystem_BenefitImage = 21, // nur das Bild
  Inhouse_Landingpage_Image = 22, // nur das Bild
  Inhouse_ServiceCalls = 23,
  Inhouse_GroupOrder_Image = 24, // nur das Bild
  Inhouse_GroupInvitation_Image = 25, // nur das Bild
  Inhouse_ePing_Image = 26, // nur das Bild
  Inhouse_ePing_Icon_Image = 27, // nur das Bild
  RecipeLinking = 28,
  Webvoucher_Landingpage_Image = 29, // nur das Bild
  Webvoucher_Custom = 30,
  Webvoucher_Layout_Preview = 31, // nur das Bild
  Webvoucher_Charge_Image = 32, // nur das Bild
  Language = 33, // nur das Bild
  GroupOrderInvitationImage = 34,
  GroupOrderSelectorImage = 35,
  // private Types, there are not qual to ContentType on YourAppServer, only for internal usage
  // SOT Bereich 900-999
  SOTLogoImage = 900, // nur das Bild
  SOTPaymentImage = 901, // nur das Bild
  SOTStartpage = 902,
  SOTAdvertisement = 903,
  SOTItemGroup = 904,
  /** ACHTUNG! MenuSettings wird in der YourAPP Webshop genannt als 20 verwendet */
  MenuSettings = 1000, // 1000, damit die 999 für die kommenden festen ContenTypes freibleiben
  // Hier kommen die Contenttypes, bei denen die Nummer keine Synchronisation mit dem YourAppServer benötigt.
  // Wichtig: neue Einträge müssen unten angefügt werden, damit die APP weiter funktioniert
  // Achtung: es dürfen keine Änderungen an der Reihenfolge vorgenommen werden (nicht löschen oder veschieben)
  ReservationSettings,
  Like,
  Rating,
  Feedback,
  Local_ValueStorage,
  Server_ValueStorage,
  Bonusaction,
  BonusactionBenefit,
  OrderHistory,
  BlackWhiteList,
  BonusactionSettings,
  ExternalLinksSettings,
  WebshopSettings,
  ArticleAvailabililty,
  SOTLanguages,
  SOTStyle,
  SOTSettings,
  SOTRecommendationRules,
  ProductTag,
  sub_WebshopLanguages,
  WebshopColorTokens,
  // neue einträge unten einfügen
}

/** ContentTypes welche nur einem Kunden zugeordnet sind */
export const UserContentTypes: ReadonlyArray<ContentType> = [
  ContentType.Like,
  ContentType.Rating,
  ContentType.OrderHistory,
];

/** die entsprechenden Namen zu dem Content, wird zum persistenten speichern verwendet */
export enum ContentDir {
  News = "news",
  Coupon = "coupon",
  Event = "event",
  Aktion = "aktion",
  Location = "location",
  Menu = "menu",
  Bonussystem = "bonussystem",
  Reservation = "reservation",
  WebVoucher = "web_voucher",
  Impressum = "impressum",
  Term = "term",
  Home_Slider = "home_slider",
  Home_PrioTile = "home_prio_tile",
  Home_Tile = "home_tile",
  Settings = "settings",
  Navigation = "navigation",
  Item_Group = "item_group",
  Product = "product",
  ArticleAvailabililty = "article_availibilty",
  Product_Group = "product_group",
  MenuSettings = "menu_settings",
  WebshopSettings = "webshop_settings",
  WebshopColorTokens = "webshop_color_tokens",
  ReservationSettings = "reservation_settings",
  Like = "like",
  Rating = "rating",
  Feedback = "feedback",
  Local_ValueStorage = "local_value_storage",
  Server_ValueStorage = "server_value_storage",
  Bonusaction = "bonusaction",
  BonusactionBenefit = "bonusaction_benefit",
  BlackWhiteList = "black_white_list",
  BonusactionSettings = "bonusaction_settings",
  ExternalLinksSettings = "external_links_settings",
  GroupOrderInvitationImage = "group_order_invitation_image",
  GroupOrderSelectorImage = "group_order_selector_image",
  SOTLanguages = "sot_languages",
  SOTSettings = "sot_settings",
  SOTStyle = "sot_style",
  SOTItemGroup = "sot_item_group",
  SOTRecommendationRules = "sot_recommendation_rules",
  SOTStartpage = "sot_startpage",
  SOTAdvertisement = "sot_advertisement",
  ProductTag = "product_tag",
  WebshopLanguages = "webshop_languages",
  Inhouse_ServiceCalls = "servicecall",
  OrderHistory = "order_history",
  RecipeLinking = "recipe_linking",
  Webvoucher_Custom = "webvoucher_custom",
  Webvoucher_Layout_Preview = "webvoucher_layout_preview",
}

export function GetContentDirFromType(type: ContentType): ContentDir {
  switch (type) {
    case ContentType.News:
      return ContentDir.News;
    case ContentType.Coupon:
      return ContentDir.Coupon;
    case ContentType.Event:
      return ContentDir.Event;
    case ContentType.Aktion:
      return ContentDir.Aktion;
    case ContentType.Location:
      return ContentDir.Location;
    case ContentType.Menu:
      return ContentDir.Menu;
    case ContentType.Bonussystem:
      return ContentDir.Bonussystem;
    case ContentType.Reservation:
      return ContentDir.Reservation;
    case ContentType.WebVoucher:
      return ContentDir.WebVoucher;
    case ContentType.Impressum:
      return ContentDir.Impressum;
    case ContentType.Term:
      return ContentDir.Term;
    case ContentType.Home_Slider:
      return ContentDir.Home_Slider;
    case ContentType.Home_PrioTile:
      return ContentDir.Home_PrioTile;
    case ContentType.Home_Tile:
      return ContentDir.Home_Tile;
    case ContentType.Settings:
      return ContentDir.Settings;
    case ContentType.Navigation:
      return ContentDir.Navigation;
    case ContentType.Item_Group:
      return ContentDir.Item_Group;

    case ContentType.MenuSettings:
      return ContentDir.MenuSettings;
    case ContentType.WebshopSettings:
      return ContentDir.WebshopSettings;
    case ContentType.WebshopColorTokens:
      return ContentDir.WebshopColorTokens;
    case ContentType.ReservationSettings:
      return ContentDir.ReservationSettings;
    case ContentType.Like:
      return ContentDir.Like;
    case ContentType.Rating:
      return ContentDir.Rating;
    case ContentType.Feedback:
      return ContentDir.Feedback;
    case ContentType.Local_ValueStorage:
      return ContentDir.Local_ValueStorage;
    case ContentType.Server_ValueStorage:
      return ContentDir.Server_ValueStorage;
    case ContentType.Bonusaction:
      return ContentDir.Bonusaction;
    case ContentType.BonusactionBenefit:
      return ContentDir.BonusactionBenefit;
    case ContentType.sub_Product:
      return ContentDir.Product;
    case ContentType.ArticleAvailabililty:
      return ContentDir.ArticleAvailabililty;
    case ContentType.BlackWhiteList:
      return ContentDir.BlackWhiteList;
    case ContentType.BonusactionSettings:
      return ContentDir.BonusactionSettings;
    case ContentType.ExternalLinksSettings:
      return ContentDir.ExternalLinksSettings;
    case ContentType.ProductTag:
      return ContentDir.ProductTag;
    case ContentType.Inhouse_ServiceCalls:
      return ContentDir.Inhouse_ServiceCalls;
    case ContentType.OrderHistory:
      return ContentDir.OrderHistory;
    case ContentType.RecipeLinking:
      return ContentDir.RecipeLinking;
    case ContentType.Webvoucher_Custom:
      return ContentDir.Webvoucher_Custom;
    case ContentType.Webvoucher_Layout_Preview:
      return ContentDir.Webvoucher_Layout_Preview;
    case ContentType.sub_WebshopLanguages:
      return ContentDir.WebshopLanguages;
    case ContentType.GroupOrderInvitationImage:
      return ContentDir.GroupOrderInvitationImage
    case ContentType.GroupOrderSelectorImage:
      return ContentDir.GroupOrderSelectorImage
    // SOT
    case ContentType.SOTLanguages:
      return ContentDir.SOTLanguages;
    case ContentType.SOTSettings:
      return ContentDir.SOTSettings;
    case ContentType.SOTStyle:
      return ContentDir.SOTStyle;
    case ContentType.SOTItemGroup:
      return ContentDir.SOTItemGroup;
    case ContentType.SOTRecommendationRules:
      return ContentDir.SOTRecommendationRules;
    case ContentType.SOTStartpage:
      return ContentDir.SOTStartpage;
    case ContentType.SOTAdvertisement:
      return ContentDir.SOTAdvertisement;
    default:
      return null;
  }
}

/** Static class for holding relevant groups of ContentTypes */
export class ContentTypeGroups {
  private static _deleteLocalStoragedDataAllowedContentTypes: Array<ContentType>;
  /** List of the ContentTypes, that is allowed to delete from storage */
  public static deleteLocalStoragedDataAllowedContentTypes(
    producttype: YourAPPProductType
  ): Array<ContentType> {
    if (!ContentTypeGroups._deleteLocalStoragedDataAllowedContentTypes) {
      if (producttype == YourAPPProductType.sot) {
        ContentTypeGroups._deleteLocalStoragedDataAllowedContentTypes = [
          // at moment no data for delete
        ];
      } else {
        ContentTypeGroups._deleteLocalStoragedDataAllowedContentTypes = [
          // user specific content
          ...UserContentTypes,
        ];
      }
    }
    return ContentTypeGroups._deleteLocalStoragedDataAllowedContentTypes;
  }

  private static _autoSyncAllowedContentTypes: Array<ContentType>;
  /** List of the ContentTypes, for synchronise with the server by CompleteSynchronizeWithServer
   * @param producttype je typ können unterschiedliche daten abgerufen werden
   * @param setup_sync wird es mit true aufrufen um die initialen assets daten vom server zu laden (siehe get_server_data.ts)
   */
  public static autoSyncAllowedContentTypes(
    producttype: YourAPPProductType,
    setup_sync: boolean
  ): Array<ContentType> {
    if (!ContentTypeGroups._autoSyncAllowedContentTypes) {
      if (producttype == YourAPPProductType.sot) {
        ContentTypeGroups._autoSyncAllowedContentTypes = [
          // SOT hat nur Location abhängige daten, damit also kein auto sync der SOT Daten
        ];
        // dynamische Daten, die nicht in de Assets der initalen/setup app gehören
        if (!setup_sync) {
          ContentTypeGroups._autoSyncAllowedContentTypes.push(
            ...[
              ContentType.ArticleAvailabililty, // enthält die Verfügbarkeit aller Standorte
            ]
          );
        }
      } else {
        ContentTypeGroups._autoSyncAllowedContentTypes = [
          ContentType.Impressum,
          ContentType.Term,
          ContentType.Navigation,
          ContentType.Item_Group,
          ContentType.Home_Slider,
          ContentType.Home_Tile,
          ContentType.Home_PrioTile,
          ContentType.Location,
          ContentType.News,
          ContentType.Coupon,
          ContentType.Event,
          ContentType.BonusactionSettings,
          ContentType.Bonusaction,
          ContentType.BonusactionBenefit,
          ContentType.Settings,
          ContentType.MenuSettings, // attention see objectObserverSyncHelper.ts combined to sub_Product
          // ContentType.sub_Product, // attention see objectObserverSyncHelper.ts combined to MenuSettings (handle also the ProductDetails)
          ContentType.WebshopSettings,
          ContentType.WebshopColorTokens,
          ContentType.ReservationSettings,
          ContentType.Inhouse_ServiceCalls,
          ContentType.BlackWhiteList,
          ContentType.ExternalLinksSettings,
          ContentType.RecipeLinking,
          ContentType.Webvoucher_Custom,
          ContentType.Webvoucher_Layout_Preview
          // ATTENTION: Look to the get_server_data.ts, if change something
        ];
        // dynamische Daten, die nicht in de Assets der initalen/setup app gehören
        if (!setup_sync) {
          ContentTypeGroups._autoSyncAllowedContentTypes.push(
            ...[
              ContentType.ArticleAvailabililty,
              // user specific content
              ...UserContentTypes,
            ]
          );
        }
      }
    }
    return this._autoSyncAllowedContentTypes;
  }

  /** Constructor is privet because it is a static class */
  private constructor() { }
}

/** 3 main parts of the home */
export enum MainTemplateType {
  Tiles = 1,
  Bars = 2,
  Sliber = 3,
}

/**  In YourAPP defenierte größen der vorliegenden Bilder */
export enum ImageWidthSizes {
  Size1 = 320,
  Size2 = 828,
  Size3 = 1242,
  Size4 = 1536,
  Size5 = 2960,
}

/** Orientierung des Bildformats */
export enum ImageOrientation {
  Portrait = 101,
  Landscape = 102,
}

export enum SortDirection {
  ASC = 1,
  DESC = -1,
}

// name of the class for customizing snackBar message
export enum SnackBarMessageType {
  Normal = "snackbar-normal-message",
  Successful = "snackbar-successful-message",
  Error = "snackbar-error-message",
  Warning = "snackbar-warning-message",
  Info = "snackbar-info-message",
}

export enum PhoneCallError {
  feature = "feature",
  notcall = "notcall",
  empty = "empty",
}

export enum CustomAction {
  callAction,
  directionAction,
  emailAction,
  reservationAction,
}

export enum RegetrationTab {
  Register,
  Login,
}

export enum LoginStatus {
  LogedIn,
  NotVerified,
  WrongUserOrPassword,
  IncompleteRegistration,
}

export enum DateFormatTyps {
  DDMMYYYY_HHMMSS = 0,
  DDMMYYYY_HHMM = 1,
  DDMMYYYY = 2,
  HHMMSS = 3,
  HHMM = 4,
  YYYY = 5,
  MMMM_YYYY = 6,
  DDDD_D_MMMM_YYYY = 7,
  CW_YYYY = 8,
  MMYYYY = 9,
  DDDD = 10,
  MMM_YY = 11,
  MMM_YYYY = 12,
  CW = 13,
  W = 14,
}

export enum Gender {
  None = 0,
  Woman = 1,
  Man = 2,
  Divers = 3,
}

export enum Prefix {
  None = 0,
  Man = 1,
  Woman = 2,
  Divers = 3,
}

// define text color for dark or light background
export enum StatusBarTextStyle {
  styleDefault,
  styleLightContent,
  styleBlackTranslucent,
  styleBlackOpaque,
}

export enum PopStateDirection {
  Imprative,
  Backward,
  Forward,
}

export enum ExternalLinkSource {
  ContentExtra,
  ExternaLinksSettings,
}

export enum OrderDataInputFields {
  prefix = 2,
  fname = 4,
  name = 3,
  co = 5,
  address = 7,
  addition = 21,
  zip_code = 9,
  city = 10,
  country = 6,
  email = 31,
  telephone1 = 11,
  telephone2 = 12, // workphone
  telephone_mobile = 13,
  bday_ymd = 18,
}

/**
 * RegistrationInputFieldIds - Field IDs for registration form configuration
 * IMPORTANT: These numbers MUST match the serverside field IDs exactly!
 */
export enum RegistrationInputFieldIDs {
  prefix = 2,
  name = 3,
  fname = 4,
  co = 5,
  country = 6,
  address = 7,
  zip_code = 9,
  city = 10,
  telephone1 = 11,
  telephone2 = 12,
  telephone_mobile = 13,
  bday_ymd = 18,
  addition = 21,
}

export enum InputDataType {
  text = "text",
  date = "date",
}

export enum OrderDataAddressFieldInputs {
  co = 5,
  address = 7,
  addition = 21,
  zip_code = 9,
  city = 10,
  country = 6,
}

export enum OrderDataInputMaxLength {
  prefix = 10,
  fname = 30,
  name = 30,
  co = 30,
  address = 40,
  addition = 25,
  zip_code = 10,
  city = 30,
  country = 30,
  email = 63,
  telephone1 = 20,
  telephone2 = 20,
  telephone_mobile = 20,
  phone_number = 16
}

/** Maximum input lengths for various fields */
export enum InputValidationMaxLength {
  prefix = 10,
  fname = 30,
  name = 30,
  co = 30,
  address = 40,
  addition = 25,
  zip_code = 10,
  city = 30,
  country = 30,
  email = 63,
  telephone1 = 20,
  telephone2 = 20,
  telephone_mobile = 20,
  phone_number = 16,
  dateDD = 2,
  dateMM = 2,
  dateYYYY = 4,
}

/** Minimum input lengths for various fields */
export enum InputValidationMinLength {
  street = 3,
  name = 3,
  fname = 3,
  phone = 6,
  dateDD = 2,
  dateMM = 2,
  dateYYYY = 4,
}

/**
 * Maximum input lengths for delivery address fields.
 * Note:DB can only handle a combined address and house number field with
 * a maximum length of 40 characters (OrderDataInputMaxLength.address).
 * These values are for separate fields.
 */
export enum DeliveryAddressQueryMaxLength {
  street = 35,
  houseNumber = 5,
}

export enum YourAPPProductType {
  app_android,
  app_ios,
  emenu,
  webshop,
  sot,
}

export enum WebShopMode {
  Viewing = 0,
  TakeAway = 1,
  Delivery = 2,
  OrderToTable = 3,
  OrderAhead = 4,
  ExternalBasket = 5,
  Retail = 6,
  Ticket = 7,
  Webvoucher = 8,
  PickupGroup = 9,
  DeliveryGroup = 10,
}

/** obsolete, benutze anstatt WebShopMode */
export enum orderTypes {
  allUnknown = 0,
  pickup = 1,
  delivery = 2,
  inHouse = 3,
  orderAhead = 4,
  externalBasket = 5,
  retail = 6,
  ticket = 7,
  webvoucher = 8,
  pickupGroup = 9,
  deliveryGroup = 10,
}

export enum CameraMode {
  Front = "front",
  Back = "back",
  Rear = "rear",
}

export enum VoucherServiceType {
  Charge,
  Order,
}

export enum DeliveryAddressType {
  OldDeliveryAddress = 1,
  NewDeliveryAddress = 2,
}

export enum AnounceModalResult {
  FirstButton = 1,
  SecondButton = 2,
  ThirdButton = 3,
}

export enum AGBConfirmationDialogResult {
  Accepted = 1,
  Denied = 2,
  OpenTerm = 3,
}

export enum NotificationsState {
  Cancelled = 1,
  Accepted = 2,
  AlreadyExists = 3,
  EPingDisabled = 4,
  SuccessfullySet = 5,
  FailedToSet = 6,
}

export enum PaymentModalResult {
  FirstButton = 1,
  SecondButton = 2,
  ThirdButton = 3,
}

export enum AddressModalResult {
  FirstButton = 1,
  SecondButton = 2,
  ThirdButton = 3,
}

export enum ContinueShoppingAction {
  AddToGroupBasket = 1,
  OrderDirectly,
  GoToMenuGroup,
  GoToBasket,
  Overview,

}

export enum UseServiceTypeField {
  UsedDelivery = "usedDelivery",
  UsedPickUp = "usedPickUp",
  UsedInHouse = "usedInHouse",
  UsedWebvoucher = "usedWebvoucher",
}

export enum RequiredServiceTypeFieled {
  RequiredDelivery = "requiredDelivery",
  RequiredPickUp = "requiredPickUp",
  RequiredInHouse = "requiredInHouse",
  RequiredWebvoucher = "requiredWebvoucher",
}

export enum RemoveCustomerFurtherAddressSuccessModelErrorCode {
  UndefinedError = 0,
  NoAccountID = 1,
  NoRequestData = 2,
  ResponseIsEmpty = 3,
  ResponseDataIsEmpty = 4,
  ResponseDataSetIsEmpty = 5,
  InvalidRequest = 6,
  ValidationError = 7,
  DataRecordCreationNotpossible = 8,
  UnKnownConnectorError = 9,
  AccountIDnotCorrect = 10,
  CustomerFurtherAddressIDnotCorrect = 11,
}

export enum LocationServiceStatus {
  IsNotActivated, // location service is off
  Authorized, // locationservice has permission
  NotAuthorized, // locationservice has not permission
  BrowserMode, // using browser
  ResponseError, // catch Error on Function
}

export enum ItemTagType {
  Icon = 0,
  Text = 1,
}

export enum ItemTagStatusType {
  like = 0,
  neutral = 1,
  dislike = 2,
}

export enum RedeemType {
  Benefit = 0,
  Coupon,
}

export enum BenefitRedemptionStatus {
  OK = 'OK',
  NoProduct = 'NoProduct',
  NotAvailable = 'NotAvailable'
}

export enum OrdereRequirementsStatus {
  OK = 'OK',
  AddressRequired = 'AddressRequired',
  TimeRequired = 'TimeRequired',
}

/**
 * TranslationContentType wird beim Zugriff auf die mehrfachgenutzten Inhalte der Tabelle WebshopLanguageTanslations benötigt
 * max 32000 nicht überschreiten, Einschränkung smallint Datenbank
 */
export enum TranslationContentType {
  /** Start Index für Artikel Languages. */
  Article_Start = 100,
  /** Bontext des Artikels, benötigt die Product.ID (nicht ProductID) */
  Article_Bontext = 101,
  /** Suchwörter des Artikels, benötigt die Product.ID (nicht ProductID) */
  Article_Suchstichwort = 102,
  /** Beschreibung des Artikels, benötigt die Product.ID (nicht ProductID) */
  Article_Details = 103,
  /** Inhaltsstoffe des Artikels, benötigt die Product.ID (nicht ProductID) */
  Article_ItemContent = 104,
  /** Inverkehrbringer des Artikels, benötigt die Product.ID (nicht ProductID) */
  Article_ItemProviderName = 105,
  /** Adresse vom Inverkehrbringer des Artikels, benötint die Product.ID (nicht ProductID) */
  Article_ItemProviderAddr = 106,
  /** Abschluss Index für Artikel Languages */
  Article_Ende = 199,
  /** Start Index für Rezepturverkättungen Languages. Rezepturverkettung ist global ohne HypCusNr wird immer mit HypCusNr-1 abgefragt*/
  RecipeLinking_Start = 200,
  /** Rezepturverlinkung Bezeichnung, benötigt die RecipeLinking.ID */
  RecipeLinking_Name = 201,
  /** Rezepturverlinkung Beschreibung, benötigt die RecipeLinking.ID */
  RecipeLinking_Details = 202,
  /** Rezepturverlinkung Überschrift, benötigt die RecipeLinking.ID */
  RecipeLinking_Heading = 203,
  /** Ende Index für Rezepturverkättungen Languages */
  RecipeLinking_Ende = 299,
  /** Start Index für ArtikelTag Languages. Artikeltag ist global ohne HypCusNr wird immer mit HypCusNr-1 abgefragt */
  ArticleTag_Start = 300,
  /** ArtikelTAG Bezeichnung, benötigt die ArticleTag.ID */
  ArticleTag_Name = 301,
  /** Abschluss Index für ArtikelTag Languages */
  ArticleTag_Ende = 399,
  /** Start Index für SOT Warengruppe Languages. Zentrale = zentrale HypCusNr. NICHT -1. Achtung: Wenn Zentrale = Filiale, dann gleiche Daten*/
  SOT_ItemGroup_Start = 400,
  /** SOT Warengruppen Bezeichnung, benötigt die SOTItemGroup.ID */
  SOT_ItemGroup_Label = 401,
  /** SOT Warengruppen Beschreibung, benötigt die SOTItemGroup.ID */
  SOT_ItemGroup_Description = 402,
  /** Abschluss Index für SOT Warengruppe Languages */
  SOT_ItemGroup_Ende = 499,
  /** Start Index für Empfehlungen Languages. Zentrale = zentrale HypCusNr. NICHT -1. Achtung: Wenn Zentrale = Filiale, dann gleiche Daten */
  SOT_ItemGroup_RecommendationArticleGroup_Start = 500,
  /** Bezeichnung der Warengruppen Empfehlung,
   * ACHTUNG: ContenID setzt sich zusammen aus (sort_no * 1000000) + SOTItemGroupDataModel.id
   * Benutze: WebshopLanguagesDataModel.GetSOTItemGroupRecommendationArticleGroup_ContentID */
  SOT_ItemGroup_RecommendationArticleGroup_Title = 501,
  /** Abschluss Index für Empfehlungen Languages */
  SOT_ItemGroup_RecommendationArticleGroup_Ende = 599,
  /** Start Index für ArtikelExtra Languages. */
  ArticleExtra_Start = 600,
  /** Artikelbezeichnung des Abfrage Artikels, benötigt die ArticleExtra.ID */
  ArticleExtra_Artikel_Name = 601,
  /** Abschluss Index für ArtikelExtra Languages */
  ArticleExtra_Ende = 699,
  /** Start Index für ArtikelExtraText Languages. */
  ArticleExtratext_Start = 700,
  /** Abfragenbezeichnung benötigt die productdetails.id */
  ArticleExtratext_AB1 = 701,
  ArticleExtratext_AB2 = 702,
  ArticleExtratext_AB3 = 703,
  ArticleExtratext_AB4 = 704,
  ArticleExtratext_AB5 = 705,
  ArticleExtratext_AB6 = 706,
  ArticleExtratext_AB7 = 707,
  ArticleExtratext_AB8 = 708,
  ArticleExtratext_AB9 = 709,
  ArticleExtratext_AB10 = 710,
  ArticleExtratext_AB11 = 711,
  ArticleExtratext_AB12 = 712,
  ArticleExtratext_AB13 = 713,
  ArticleExtratext_AB14 = 714,
  ArticleExtratext_AB15 = 715,
  ArticleExtratext_AB16 = 716,
  /** Abschluss Index für ArtikelExtraText Languages */
  ArticleExtratext_Ende = 799
  // max 32000 nicht überschreiten, Einschränkung smallint Datenbank
}

/** Prüft den TranslationContentType und gibt an, ob in der Zentrale gespeichert ist.
 * Einnige der Übersetzungen werden nicht in dem Standort sondern global in der Zentrale gespeichert.
 * @param type zu prüfender TranslationContentType
 */
export function IsTranslationContentTypeInCentral(type: TranslationContentType): boolean {
  return (type > TranslationContentType.RecipeLinking_Start && type < TranslationContentType.RecipeLinking_Ende)
    || (type > TranslationContentType.ArticleTag_Start && type < TranslationContentType.ArticleTag_Ende);
}